module.exports = __webpack_public_path__ + "img/paymentReconciled.095af0ef.svg";